import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ApiError } from '../api';
import { inviteUser } from '../api/users';
import { Queries } from '../types/queries';

/** The API created the user but could not deliver its login link. */
export const invitationPartialSuccessStatus = 422;

/** Invites a user and refreshes the user directory whenever the directory changed. */
const useInviteUser = () => {
  const queryClient = useQueryClient();
  const invalidateUsers = () => queryClient.invalidateQueries({ queryKey: [Queries.UserList] });
  return useMutation({
    mutationFn: inviteUser,
    onSuccess: invalidateUsers,
    // A partial success still created the user, so the directory must refresh for the resend
    // login link action to become reachable for that user.
    onError: (error) => {
      if (error instanceof ApiError && error.status === invitationPartialSuccessStatus) void invalidateUsers();
    },
  });
};

export default useInviteUser;
